import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const ticketsApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get single ticket
    getTicketByTicketId: builder.query({
      query: ({ ticketId }) => ({
        url: `${API_BASE_URL}/tickets/ticket/${ticketId}`,
        method: "GET",
      }),
      providesTags: (result, error, ticketId) => [
        { type: "Ticket", id: ticketId },
      ],
    }),
    // get user's tickets
    getTicketsByUserId: builder.query({
      query: ({ userId, page, queryFilters }) => {
        let params = new URLSearchParams();
        params.append("page", page);
        params.append("user_id", userId);
        if (Object.keys(queryFilters).length > 0) {
          Object.keys(queryFilters).forEach((key) => {
            if (queryFilters[key]) {
              params.append(key, queryFilters[key]);
            }
          });
        }
        return {
          url: `${API_BASE_URL}/tickets?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: (result) => {
        if (result && Array.isArray(result.paginated_results)) {
          return [
            ...result.paginated_results.map(({ id }) => ({
              type: "Ticket",
              id,
            })),
            { type: "TicketList", id: "LIST" },
          ];
        }
        return [{ type: "TicketList", id: "LIST" }];
      },
    }),
    // get user's tickets related to the admin
    getTicketsByAdminId: builder.query({
      query: ({ adminId, page, queryFilters }) => {
        let params = new URLSearchParams();
        params.append("page", page);
        params.append("admin_id", adminId);
        if (Object.keys(queryFilters).length > 0) {
          Object.keys(queryFilters).forEach((key) => {
            if (queryFilters[key]) {
              params.append(key, queryFilters[key]);
            }
          });
        }
        return {
          url: `${API_BASE_URL}/tickets?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: (result) => {
        if (result && Array.isArray(result.paginated_results)) {
          return [
            ...result.paginated_results.map(({ id }) => ({
              type: "Ticket",
              id,
            })),
            { type: "TicketList", id: "LIST" },
          ];
        }
        return [{ type: "TicketList", id: "LIST" }];
      },
    }),

    updateSingleTicket: builder.mutation({
      query: ({ ticketId, userId, formData }) => ({
        url: `${API_BASE_URL}/tickets/${ticketId}/${userId}`,
        method: "PUT",
        body: formData,
        formData: true,
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: "Ticket", id: ticketId },
        { type: "TicketList", id: "LIST" },
      ],
    }),
    addMessageToTicket: builder.mutation({
      query: ({ ticketId, userId, messageData }) => ({
        url: `${API_BASE_URL}/ticket_messages/${ticketId}/${userId}`,
        method: "POST",
        body: messageData,
        formData: true,
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: "Ticket", id: ticketId },
        { type: "TicketList", id: "LIST" },
      ],
    }),
    getTicketCategories: builder.query({
      query: () => ({
        url: `${API_BASE_URL}/ticket_categories`,
        method: "GET",
      }),
      providesTags: ["TicketCategories"],
    }),
    createTicket: builder.mutation({
      query: ({ userId, projectId, formData }) => ({
        url: `${API_BASE_URL}/tickets/${userId}/${projectId}`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: [{ type: "Tickets", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTicketByTicketIdQuery,
  useGetTicketsByUserIdQuery,
  useGetTicketsByAdminIdQuery,
  useUpdateSingleTicketMutation,
  useAddMessageToTicketMutation,
  useGetTicketCategoriesQuery,
  useCreateTicketMutation,
} = ticketsApi;
